var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import BaseVideoNode from '../base/base-videonode';
import { PLAY_MODE, PRELOAD_TYPE, VIDEO_STATE } from '../enums';
import SimpleDefer from '../libs/simple-defer';
import { Logger } from '../log';
import { logMethodCallDecoratorCreator, uaTool, videoTool } from '../util';
var logMethodCall = logMethodCallDecoratorCreator('OrgVideoNode');
/**
 * 使用原生的video标签播放单个视频。
 */
var OrgVideoNode = /** @class */ (function (_super) {
    __extends(OrgVideoNode, _super);
    function OrgVideoNode(config) {
        var _this = _super.call(this, config) || this;
        _this._logger = new Logger(config.instanceId, 'OrgVideoNode');
        return _this;
    }
    OrgVideoNode.prototype.onVideoEventCanplay = function () {
        var _a;
        (_a = this.canplayDefer) === null || _a === void 0 ? void 0 : _a.resolve();
        _super.prototype.onVideoEventCanplay.call(this);
    };
    OrgVideoNode.prototype.onVideoEventLoadedmetadata = function () {
        _super.prototype.onVideoEventLoadedmetadata.call(this);
        if ((uaTool.os.ios || uaTool.browser.safari)
            && [PRELOAD_TYPE.META_DATA, PRELOAD_TYPE.AUTO].includes(this._config.preloadType)) {
            // ios和mac safari如果是只加载头部数据，不会发出canplay事件。这时候就需要强制成canplay，然后才可以清除预加载超时，并能触发播放
            this.onVideoEventCanplay();
        }
    };
    OrgVideoNode.prototype.onVideoEventLoadeddata = function () {
        _super.prototype.onVideoEventLoadeddata.call(this);
        // ios要在canplay以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
        this.checkPlayInitSeek();
    };
    OrgVideoNode.prototype.onVideoEventTimeUpdate = function () {
        _super.prototype.onVideoEventTimeUpdate.call(this);
        // x5要在timeupdate以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
        this.checkPlayInitSeek();
    };
    OrgVideoNode.prototype.onVideoEventLoadStart = function () {
        this.resolveWaitVideoLoadStartEvt();
    };
    OrgVideoNode.prototype.load = function (videoInfo, opts) {
        var _this = this;
        if (!videoInfo.loadingUrl) {
            return false;
        }
        this.stopInner(true);
        this._drm.init(videoInfo.config.drmConfig);
        this._videoInfo = videoInfo;
        this._videoInfo.extraVars.isLoadstarted = true;
        this.setVideoEvents(true);
        this.stateMgr.setLoadStart();
        this.assignStartTime((opts === null || opts === void 0 ? void 0 : opts.startTime) || 0);
        this._video.src = this._videoInfo.loadingUrl;
        this._logger.log("load(), uid=".concat(this._videoInfo.uid));
        if (this._config.preloadType === PRELOAD_TYPE.AUTO_LOAD) {
            this._video.load();
        }
        this.setCheckLoadTimeoutEnable(true);
        this.canplayDefer = new SimpleDefer();
        this.waitVideoLoadStartEvt()
            .then(function () {
            // 收到了loadStart事件
            _this._logger.log('load(), video load succ...');
        })
            .catch(function () {
            _this._logger.error('load(), video load cannot be trigger...');
            // 没收到loadStart事件，等待超时
            _this.onVideoEventCanplay();
        });
        return true;
    };
    OrgVideoNode.prototype.play = function (videoInfo, opts) {
        var _this = this;
        this._logger.log("play(), uid=".concat(videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.uid, "/idx=").concat(this.idx, "/state=").concat(this.state));
        this._played = true;
        if (videoInfo && !videoInfo.extraVars.isLoadstarted) {
            // 如果没有开始加载，尝试加载视频
            this.load(videoInfo, opts);
        }
        var playPromise = null;
        if (uaTool.browser.safari && this.canplayDefer) {
            // 调用load以后，如果马上play，目前safari会无法检测到自动播放，因此safari的话等canplay后再调用play播放
            // 看下面示例代码在safari中的运行可以看到这里修改的原因
            // var videoTag = document.querySelector('video');
            // videoTag.src = '//' + location.host + '/assets/u3139lwnb4l.mp4'
            // videoTag.load();
            // // 如果马上调用
            // videoTag.play().catch(function (e) {
            //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);// AbortError, The operation was aborted
            // });
            // // 如果在canplay后调用
            // videoTag.addEventListener('canplay', function() {
            //   videoTag.play().catch(function (e) {
            // NotAllowedError, The request is not allowed by ...
            //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);
            // });
            // // })
            this.canplayDefer.promise.then(function () {
                _this.videoplay();
            });
        }
        else {
            playPromise = this.videoplay();
        }
        this.setMainLoopEnable(true);
        return playPromise;
    };
    /**
     * 指定起播时间
     * @param startTime 起播时间点
     * @returns void
     */
    OrgVideoNode.prototype.assignStartTime = function (startTime) {
        if (this._config.type === PLAY_MODE.LIVE) {
            // 指定起播点只有点播模式下才生效
            return;
        }
        this._userStartTime = startTime;
        var playtime = !Number.isNaN(startTime) && startTime >= 0 ? startTime : 0;
        if (playtime <= 0) {
            return;
        }
        if (videoTool.supportMediaFragmentsURISpec(this._config.enableMediaFragmentsURI)
            && !this._videoInfo.loadingUrl.startsWith('blob:')) {
            this._logger.log('assignStartTime by #t');
            // url直接指定#t参数，但blob地址不支持指定播放起点
            this._videoInfo.setLoadingUrlStartTime(playtime);
        }
        else {
            this._logger.log('assignStartTime with seek()');
            // 开播以后seek到目标点
            this.needPlaySeektime = playtime;
        }
    };
    OrgVideoNode.prototype.checkPlayInitSeek = function () {
        if (this.needPlaySeektime > 0 && this._videoInfo && this._video.duration > 0) {
            // 判断的最后一个条件是因为一般video的duration<=0时都无法seek
            this._logger.log("checkPlayInitSeek(), idx=".concat(this.idx, "/seektime=").concat(this.needPlaySeektime));
            this.seek(this.needPlaySeektime);
            this.needPlaySeektime = 0;
        }
    };
    OrgVideoNode.prototype.stopInner = function (keepState, videoInfo) {
        this.canplayDefer = null;
        this.needPlaySeektime = 0;
        _super.prototype.stopInner.call(this, keepState, videoInfo);
    };
    OrgVideoNode.prototype.seek = function (value, isUser) {
        if (isUser === void 0) { isUser = false; }
        var time = value;
        if (!this.checkCanSeek(time, isUser)) {
            return false;
        }
        time = this.adjustSeekTime(time);
        this._isUserSeek = isUser;
        this._logger.log("seek(), uid".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/time=").concat(time, "/duration=").concat(this._video.duration, "/")
            + "state=".concat(this.state));
        this._targetSeekTime = time;
        this._video.currentTime = time;
        return true;
    };
    OrgVideoNode.prototype.updateAccuratePlaytime = function () {
        _super.prototype.updateAccuratePlaytime.call(this);
        var leftTime = Math.abs(this._video.duration - this._video.currentTime);
        var advanceEndTime = this._config.originKernelConfig.advanceEndTime;
        if (advanceEndTime > 0 && leftTime <= advanceEndTime) {
            // 根据配置的时间提前结束当前的播放
            this._logger.log('setEndInner(), reason=leftTimeCheck');
            this.setEndInner();
        }
    };
    OrgVideoNode.prototype.setEndInner = function () {
        if (this.state !== VIDEO_STATE.END && this.state !== VIDEO_STATE.IDLE) {
            if (this.onAccurateTimeupdate) {
                this.onAccurateTimeupdate(0);
            }
            this.updatePlaytime(this._video.currentTime); // 更新更精确的时间
        }
        _super.prototype.setEndInner.call(this);
    };
    /**
   * ios的微信浏览器和x5浏览器在没有用户手势之前，调用video.load()接口，并不会有数据请求，也不会收到video组件的loadStart、canplay事件。
   * 因此我们等待一下video组件的loadStart事件，如果收到了，说明触发了数据加载，可以成功触发后续的canplay事件。但是如果一定时间后没有收到
   * loadStart事件，那么可以判断video.load()接口调用并没有任何反应。
   */
    OrgVideoNode.prototype.waitVideoLoadStartEvt = function () {
        var _this = this;
        this.waitVideoLoadStartEvtDefer = new SimpleDefer();
        // 50ms后都没有收到loadStart事件，说明video组件在调用load以后并不会触发加载行为
        var WAIT_TIME_MS = 50;
        window.setTimeout(function () {
            if (_this.waitVideoLoadStartEvtDefer.state !== 'rejected') {
                _this.waitVideoLoadStartEvtDefer.reject();
            }
        }, WAIT_TIME_MS);
        return this.waitVideoLoadStartEvtDefer.promise;
    };
    OrgVideoNode.prototype.resolveWaitVideoLoadStartEvt = function () {
        if (this.waitVideoLoadStartEvtDefer) {
            this.waitVideoLoadStartEvtDefer.resolve();
        }
    };
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "play", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "stopInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "seek", null);
    return OrgVideoNode;
}(BaseVideoNode));
export default OrgVideoNode;
